/* eslint no-param-reassign: 0 */

const initialState = {};

const gettersDef = {};

const actions = {
  fetchPermissions({ dispatch }, { params = {} } = {}) {
    return dispatch(
      "api/sendRequest",
      { method: "get", url: "/permissions/", params },
      { root: true }
    );
  }
};

const mutations = {};

export default {
  namespaced: true,
  state: initialState,
  getters: gettersDef,
  actions,
  mutations
};
